import { createWebHistory, createRouter } from "vue-router";

import { get } from "@/apis/index.js";

const routes = [
  {
    path: "/",
    component: () => import("../views/download/index.vue"),
  },
  {
    path: "/download",
    component: () => import("../views/download/index.vue"),
  },
  {
    path: "/download/page",
    component: () => import("../views/download/page.vue"),
  },
  {
    path: "/test",
    component: () => import("../views/download/test.vue"),
  },
  {
    path: "/geturl",
    component: () => import("../views/geturl/index.vue"),
  },
  {
    path: "/agreement",
    component: () => import("../views/agreement/index.vue"),
    meta: {
      title: "\u200E",
    },
  },
  {
    path: "/middlePage",
    component: () => import("../views/middlePage/index.vue"),
  },
  {
    path: "/booklet",
    component: () => import("../views/booklet/index.vue"),
    meta: {
      title: "\u200E",
    },
  },
  {
    path: "/material",
    component: () => import("../views/material/index.vue"),
    beforeEnter: (to, from, next) => {
      if (from.path === "/") {
        to.meta = { title: "\u200E", isDirect: true };
      }
      next();
    },
    meta: {
      title: "\u200E",
    },
  },
  {
    path: "/sharePage",
    component: () => import("../views/sharePage/index.vue"),
  },
  {
    path: "/bookList",
    component: () => import("../views/bookList/index.vue"),
  },
  {
    path: "/downloadApp",
    component: () => import("../views/downloadApp/index.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/",
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

const injectWx = async () => {
  const { data } = await get("/api/classpal/app/v1/h5/we-chat/getJsapiTicket", {
    // url: `http://dev.banxueketang.com${window.location.pathname}${window.location.search}`,
    url: location.href.split("#")[0],
  });
  wx.config({
    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印
    appId: data.appId, // 必填，服务号的唯一标识
    timestamp: data.timestamp, // 必填，生成签名的时间戳
    nonceStr: data.nonceStr, // 必填，生成签名的随机串
    signature: data.signature, // 必填，签名
    jsApiList: ["chooseImage"], // 必填，需要使用的JS接口列表
    openTagList: ["wx-open-launch-app", "wx-open-launch-weapp"], // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
  });
  wx.ready(() => {
    console.log("wx ready");
  });
  wx.error((err) => {
    console.log("wx err", err);
  });
};

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || "伴学课堂";
  next();
});

router.afterEach(() => {
  injectWx();
});

export default router;
